<script>
    import {createEventDispatcher} from "svelte"
    import {clickOutside} from "@/lib/utils"

    const dispatch = createEventDispatcher()

    export let popupClass = "";
    export let open
</script>

<main>
    {#if open}
        <div class="fixed top-0 bottom-0 left-0 right-0 w-full h-full z-[99999999]">
            <div class="bg-black/50 w-full h-full">
                <div class="w-full h-full flex items-center justify-center p-4">
                    <div class="bg-white w-full md:w-2/3 lg:w-1/3 max-h-[90%] overflow-y-auto p-8 {popupClass}" use:clickOutside on:clickOutside="{() => dispatch('close')}">
                        <div class="relative">
                            <button on:click={() => dispatch('close')} class="absolute top-3 right-3 material-icons-outlined">
                                <svg class="w-8 h-8" style="vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M512 960C264.97 960 64 759.03 64 512S264.97 64 512 64c247.04 0 448 200.97 448 448S759.04 960 512 960z m0-861.54C283.98 98.46 98.46 283.98 98.46 512S283.98 925.54 512 925.54 925.54 740.02 925.54 512 740.02 98.46 512 98.46z"  />
                                    <path d="M353.61 687.62c-4.41 0-8.82-1.68-12.18-5.05-6.73-6.73-6.73-17.63 0-24.37l316.78-316.78c6.73-6.73 17.63-6.73 24.37 0s6.73 17.63 0 24.37L365.79 682.57a17.14 17.14 0 0 1-12.18 5.05z"  /><path d="M670.39 687.62c-4.41 0-8.82-1.68-12.18-5.05L341.43 365.79c-6.73-6.73-6.73-17.63 0-24.37s17.63-6.73 24.37 0L682.58 658.2c6.73 6.73 6.73 17.63 0 24.37a17.18 17.18 0 0 1-12.19 5.05z"  />
                                </svg>
                            </button>
                            <slot/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
</main>